export const milesPerKM = 0.621371;
